/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppOperatorsRouteImport } from './routes/_app.operators'
import { Route as AppOkrsRouteImport } from './routes/_app.okrs'
import { Route as AppEventQueueRouteImport } from './routes/_app.event-queue'
import { Route as AppDashboardsRouteImport } from './routes/_app.dashboards'
import { Route as AppThreadIdRouteImport } from './routes/_app.$threadId'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppOperatorsIndexRouteImport } from './routes/_app.operators.index'
import { Route as AppOkrsIndexRouteImport } from './routes/_app.okrs.index'
import { Route as AppDashboardsIndexRouteImport } from './routes/_app.dashboards.index'
import { Route as AppSettingsUsageRouteImport } from './routes/_app.settings.usage'
import { Route as AppSettingsAdminRouteImport } from './routes/_app.settings.admin'
import { Route as AppSettingsAccountRouteImport } from './routes/_app.settings.account'
import { Route as AppOperatorsAutomationsRouteImport } from './routes/_app.operators.automations'
import { Route as AppOperatorsThreadIdRouteImport } from './routes/_app.operators.$threadId'
import { Route as AppOkrsOrgChartRouteImport } from './routes/_app.okrs.org-chart'
import { Route as AppOkrsOkrsRouteImport } from './routes/_app.okrs.okrs'
import { Route as AppDashboardsWebsiteTrafficRouteImport } from './routes/_app.dashboards.website-traffic'
import { Route as AppDashboardsSwitchboardRouteImport } from './routes/_app.dashboards.switchboard'
import { Route as AppDashboardsSalesRouteImport } from './routes/_app.dashboards.sales'
import { Route as AppDashboardsRevenueRouteImport } from './routes/_app.dashboards.revenue'
import { Route as AppDashboardsRetellCallsRouteImport } from './routes/_app.dashboards.retell-calls'
import { Route as AppDashboardsRespiteRouteImport } from './routes/_app.dashboards.respite'
import { Route as AppDashboardsReengagementEmailsRouteImport } from './routes/_app.dashboards.reengagement-emails'
import { Route as AppDashboardsProductPrioritiesRouteImport } from './routes/_app.dashboards.product-priorities'
import { Route as AppDashboardsInboundCallsRouteImport } from './routes/_app.dashboards.inbound-calls'
import { Route as AppDashboardsEnrollmentRouteImport } from './routes/_app.dashboards.enrollment'
import { Route as AppDashboardsEngVelocityRouteImport } from './routes/_app.dashboards.eng-velocity'
import { Route as AppDashboardsDcmpBillingRouteImport } from './routes/_app.dashboards.dcmp-billing'
import { Route as AppDashboardsDataDictionaryRouteImport } from './routes/_app.dashboards.data-dictionary'
import { Route as AppDashboardsCnCallReviewRouteImport } from './routes/_app.dashboards.cn-call-review'
import { Route as AppDashboardsCareNavigationRouteImport } from './routes/_app.dashboards.care-navigation'
import { Route as AppDashboardsCallAudioRouteImport } from './routes/_app.dashboards.call-audio'
import { Route as AppDashboardsCalKillerRouteImport } from './routes/_app.dashboards.cal-killer'
import { Route as AppDashboardsAttritionRouteImport } from './routes/_app.dashboards.attrition'
import { Route as AppDashboardsAccountManagementRouteImport } from './routes/_app.dashboards.account-management'
import { Route as AppDashboardsDashboardIdRouteImport } from './routes/_app.dashboards.$dashboardId'
import { Route as AppOperatorsSkillsIndexRouteImport } from './routes/_app.operators.skills.index'
import { Route as AppOperatorsSkillsSkillIdRouteImport } from './routes/_app.operators.skills.$skillId'
import { Route as AppDashboardsCustomSlugRouteImport } from './routes/_app.dashboards.custom.$slug'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppOperatorsRoute = AppOperatorsRouteImport.update({
  id: '/operators',
  path: '/operators',
  getParentRoute: () => AppRoute,
} as any)
const AppOkrsRoute = AppOkrsRouteImport.update({
  id: '/okrs',
  path: '/okrs',
  getParentRoute: () => AppRoute,
} as any)
const AppEventQueueRoute = AppEventQueueRouteImport.update({
  id: '/event-queue',
  path: '/event-queue',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsRoute = AppDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => AppRoute,
} as any)
const AppThreadIdRoute = AppThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppOperatorsIndexRoute = AppOperatorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOperatorsRoute,
} as any)
const AppOkrsIndexRoute = AppOkrsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOkrsRoute,
} as any)
const AppDashboardsIndexRoute = AppDashboardsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppSettingsUsageRoute = AppSettingsUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAdminRoute = AppSettingsAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppOperatorsAutomationsRoute = AppOperatorsAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AppOperatorsRoute,
} as any)
const AppOperatorsThreadIdRoute = AppOperatorsThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => AppOperatorsRoute,
} as any)
const AppOkrsOrgChartRoute = AppOkrsOrgChartRouteImport.update({
  id: '/org-chart',
  path: '/org-chart',
  getParentRoute: () => AppOkrsRoute,
} as any)
const AppOkrsOkrsRoute = AppOkrsOkrsRouteImport.update({
  id: '/okrs',
  path: '/okrs',
  getParentRoute: () => AppOkrsRoute,
} as any)
const AppDashboardsWebsiteTrafficRoute =
  AppDashboardsWebsiteTrafficRouteImport.update({
    id: '/website-traffic',
    path: '/website-traffic',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsSwitchboardRoute =
  AppDashboardsSwitchboardRouteImport.update({
    id: '/switchboard',
    path: '/switchboard',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsSalesRoute = AppDashboardsSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppDashboardsRevenueRoute = AppDashboardsRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppDashboardsRetellCallsRoute =
  AppDashboardsRetellCallsRouteImport.update({
    id: '/retell-calls',
    path: '/retell-calls',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsRespiteRoute = AppDashboardsRespiteRouteImport.update({
  id: '/respite',
  path: '/respite',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppDashboardsReengagementEmailsRoute =
  AppDashboardsReengagementEmailsRouteImport.update({
    id: '/reengagement-emails',
    path: '/reengagement-emails',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsProductPrioritiesRoute =
  AppDashboardsProductPrioritiesRouteImport.update({
    id: '/product-priorities',
    path: '/product-priorities',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsInboundCallsRoute =
  AppDashboardsInboundCallsRouteImport.update({
    id: '/inbound-calls',
    path: '/inbound-calls',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsEnrollmentRoute = AppDashboardsEnrollmentRouteImport.update({
  id: '/enrollment',
  path: '/enrollment',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppDashboardsEngVelocityRoute =
  AppDashboardsEngVelocityRouteImport.update({
    id: '/eng-velocity',
    path: '/eng-velocity',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsDcmpBillingRoute =
  AppDashboardsDcmpBillingRouteImport.update({
    id: '/dcmp-billing',
    path: '/dcmp-billing',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsDataDictionaryRoute =
  AppDashboardsDataDictionaryRouteImport.update({
    id: '/data-dictionary',
    path: '/data-dictionary',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsCnCallReviewRoute =
  AppDashboardsCnCallReviewRouteImport.update({
    id: '/cn-call-review',
    path: '/cn-call-review',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsCareNavigationRoute =
  AppDashboardsCareNavigationRouteImport.update({
    id: '/care-navigation',
    path: '/care-navigation',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsCallAudioRoute = AppDashboardsCallAudioRouteImport.update({
  id: '/call-audio',
  path: '/call-audio',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppDashboardsCalKillerRoute = AppDashboardsCalKillerRouteImport.update({
  id: '/cal-killer',
  path: '/cal-killer',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppDashboardsAttritionRoute = AppDashboardsAttritionRouteImport.update({
  id: '/attrition',
  path: '/attrition',
  getParentRoute: () => AppDashboardsRoute,
} as any)
const AppDashboardsAccountManagementRoute =
  AppDashboardsAccountManagementRouteImport.update({
    id: '/account-management',
    path: '/account-management',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppDashboardsDashboardIdRoute =
  AppDashboardsDashboardIdRouteImport.update({
    id: '/$dashboardId',
    path: '/$dashboardId',
    getParentRoute: () => AppDashboardsRoute,
  } as any)
const AppOperatorsSkillsIndexRoute = AppOperatorsSkillsIndexRouteImport.update({
  id: '/skills/',
  path: '/skills/',
  getParentRoute: () => AppOperatorsRoute,
} as any)
const AppOperatorsSkillsSkillIdRoute =
  AppOperatorsSkillsSkillIdRouteImport.update({
    id: '/skills/$skillId',
    path: '/skills/$skillId',
    getParentRoute: () => AppOperatorsRoute,
  } as any)
const AppDashboardsCustomSlugRoute = AppDashboardsCustomSlugRouteImport.update({
  id: '/custom/$slug',
  path: '/custom/$slug',
  getParentRoute: () => AppDashboardsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/$threadId': typeof AppThreadIdRoute
  '/dashboards': typeof AppDashboardsRouteWithChildren
  '/event-queue': typeof AppEventQueueRoute
  '/okrs': typeof AppOkrsRouteWithChildren
  '/operators': typeof AppOperatorsRouteWithChildren
  '/settings': typeof AppSettingsRouteWithChildren
  '/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/dashboards/account-management': typeof AppDashboardsAccountManagementRoute
  '/dashboards/attrition': typeof AppDashboardsAttritionRoute
  '/dashboards/cal-killer': typeof AppDashboardsCalKillerRoute
  '/dashboards/call-audio': typeof AppDashboardsCallAudioRoute
  '/dashboards/care-navigation': typeof AppDashboardsCareNavigationRoute
  '/dashboards/cn-call-review': typeof AppDashboardsCnCallReviewRoute
  '/dashboards/data-dictionary': typeof AppDashboardsDataDictionaryRoute
  '/dashboards/dcmp-billing': typeof AppDashboardsDcmpBillingRoute
  '/dashboards/eng-velocity': typeof AppDashboardsEngVelocityRoute
  '/dashboards/enrollment': typeof AppDashboardsEnrollmentRoute
  '/dashboards/inbound-calls': typeof AppDashboardsInboundCallsRoute
  '/dashboards/product-priorities': typeof AppDashboardsProductPrioritiesRoute
  '/dashboards/reengagement-emails': typeof AppDashboardsReengagementEmailsRoute
  '/dashboards/respite': typeof AppDashboardsRespiteRoute
  '/dashboards/retell-calls': typeof AppDashboardsRetellCallsRoute
  '/dashboards/revenue': typeof AppDashboardsRevenueRoute
  '/dashboards/sales': typeof AppDashboardsSalesRoute
  '/dashboards/switchboard': typeof AppDashboardsSwitchboardRoute
  '/dashboards/website-traffic': typeof AppDashboardsWebsiteTrafficRoute
  '/okrs/okrs': typeof AppOkrsOkrsRoute
  '/okrs/org-chart': typeof AppOkrsOrgChartRoute
  '/operators/$threadId': typeof AppOperatorsThreadIdRoute
  '/operators/automations': typeof AppOperatorsAutomationsRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/admin': typeof AppSettingsAdminRoute
  '/settings/usage': typeof AppSettingsUsageRoute
  '/dashboards/': typeof AppDashboardsIndexRoute
  '/okrs/': typeof AppOkrsIndexRoute
  '/operators/': typeof AppOperatorsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/dashboards/custom/$slug': typeof AppDashboardsCustomSlugRoute
  '/operators/skills/$skillId': typeof AppOperatorsSkillsSkillIdRoute
  '/operators/skills/': typeof AppOperatorsSkillsIndexRoute
}
export interface FileRoutesByTo {
  '/$threadId': typeof AppThreadIdRoute
  '/event-queue': typeof AppEventQueueRoute
  '/': typeof AppIndexRoute
  '/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/dashboards/account-management': typeof AppDashboardsAccountManagementRoute
  '/dashboards/attrition': typeof AppDashboardsAttritionRoute
  '/dashboards/cal-killer': typeof AppDashboardsCalKillerRoute
  '/dashboards/call-audio': typeof AppDashboardsCallAudioRoute
  '/dashboards/care-navigation': typeof AppDashboardsCareNavigationRoute
  '/dashboards/cn-call-review': typeof AppDashboardsCnCallReviewRoute
  '/dashboards/data-dictionary': typeof AppDashboardsDataDictionaryRoute
  '/dashboards/dcmp-billing': typeof AppDashboardsDcmpBillingRoute
  '/dashboards/eng-velocity': typeof AppDashboardsEngVelocityRoute
  '/dashboards/enrollment': typeof AppDashboardsEnrollmentRoute
  '/dashboards/inbound-calls': typeof AppDashboardsInboundCallsRoute
  '/dashboards/product-priorities': typeof AppDashboardsProductPrioritiesRoute
  '/dashboards/reengagement-emails': typeof AppDashboardsReengagementEmailsRoute
  '/dashboards/respite': typeof AppDashboardsRespiteRoute
  '/dashboards/retell-calls': typeof AppDashboardsRetellCallsRoute
  '/dashboards/revenue': typeof AppDashboardsRevenueRoute
  '/dashboards/sales': typeof AppDashboardsSalesRoute
  '/dashboards/switchboard': typeof AppDashboardsSwitchboardRoute
  '/dashboards/website-traffic': typeof AppDashboardsWebsiteTrafficRoute
  '/okrs/okrs': typeof AppOkrsOkrsRoute
  '/okrs/org-chart': typeof AppOkrsOrgChartRoute
  '/operators/$threadId': typeof AppOperatorsThreadIdRoute
  '/operators/automations': typeof AppOperatorsAutomationsRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/admin': typeof AppSettingsAdminRoute
  '/settings/usage': typeof AppSettingsUsageRoute
  '/dashboards': typeof AppDashboardsIndexRoute
  '/okrs': typeof AppOkrsIndexRoute
  '/operators': typeof AppOperatorsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/dashboards/custom/$slug': typeof AppDashboardsCustomSlugRoute
  '/operators/skills/$skillId': typeof AppOperatorsSkillsSkillIdRoute
  '/operators/skills': typeof AppOperatorsSkillsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/$threadId': typeof AppThreadIdRoute
  '/_app/dashboards': typeof AppDashboardsRouteWithChildren
  '/_app/event-queue': typeof AppEventQueueRoute
  '/_app/okrs': typeof AppOkrsRouteWithChildren
  '/_app/operators': typeof AppOperatorsRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/_app/dashboards/account-management': typeof AppDashboardsAccountManagementRoute
  '/_app/dashboards/attrition': typeof AppDashboardsAttritionRoute
  '/_app/dashboards/cal-killer': typeof AppDashboardsCalKillerRoute
  '/_app/dashboards/call-audio': typeof AppDashboardsCallAudioRoute
  '/_app/dashboards/care-navigation': typeof AppDashboardsCareNavigationRoute
  '/_app/dashboards/cn-call-review': typeof AppDashboardsCnCallReviewRoute
  '/_app/dashboards/data-dictionary': typeof AppDashboardsDataDictionaryRoute
  '/_app/dashboards/dcmp-billing': typeof AppDashboardsDcmpBillingRoute
  '/_app/dashboards/eng-velocity': typeof AppDashboardsEngVelocityRoute
  '/_app/dashboards/enrollment': typeof AppDashboardsEnrollmentRoute
  '/_app/dashboards/inbound-calls': typeof AppDashboardsInboundCallsRoute
  '/_app/dashboards/product-priorities': typeof AppDashboardsProductPrioritiesRoute
  '/_app/dashboards/reengagement-emails': typeof AppDashboardsReengagementEmailsRoute
  '/_app/dashboards/respite': typeof AppDashboardsRespiteRoute
  '/_app/dashboards/retell-calls': typeof AppDashboardsRetellCallsRoute
  '/_app/dashboards/revenue': typeof AppDashboardsRevenueRoute
  '/_app/dashboards/sales': typeof AppDashboardsSalesRoute
  '/_app/dashboards/switchboard': typeof AppDashboardsSwitchboardRoute
  '/_app/dashboards/website-traffic': typeof AppDashboardsWebsiteTrafficRoute
  '/_app/okrs/okrs': typeof AppOkrsOkrsRoute
  '/_app/okrs/org-chart': typeof AppOkrsOrgChartRoute
  '/_app/operators/$threadId': typeof AppOperatorsThreadIdRoute
  '/_app/operators/automations': typeof AppOperatorsAutomationsRoute
  '/_app/settings/account': typeof AppSettingsAccountRoute
  '/_app/settings/admin': typeof AppSettingsAdminRoute
  '/_app/settings/usage': typeof AppSettingsUsageRoute
  '/_app/dashboards/': typeof AppDashboardsIndexRoute
  '/_app/okrs/': typeof AppOkrsIndexRoute
  '/_app/operators/': typeof AppOperatorsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/dashboards/custom/$slug': typeof AppDashboardsCustomSlugRoute
  '/_app/operators/skills/$skillId': typeof AppOperatorsSkillsSkillIdRoute
  '/_app/operators/skills/': typeof AppOperatorsSkillsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$threadId'
    | '/dashboards'
    | '/event-queue'
    | '/okrs'
    | '/operators'
    | '/settings'
    | '/dashboards/$dashboardId'
    | '/dashboards/account-management'
    | '/dashboards/attrition'
    | '/dashboards/cal-killer'
    | '/dashboards/call-audio'
    | '/dashboards/care-navigation'
    | '/dashboards/cn-call-review'
    | '/dashboards/data-dictionary'
    | '/dashboards/dcmp-billing'
    | '/dashboards/eng-velocity'
    | '/dashboards/enrollment'
    | '/dashboards/inbound-calls'
    | '/dashboards/product-priorities'
    | '/dashboards/reengagement-emails'
    | '/dashboards/respite'
    | '/dashboards/retell-calls'
    | '/dashboards/revenue'
    | '/dashboards/sales'
    | '/dashboards/switchboard'
    | '/dashboards/website-traffic'
    | '/okrs/okrs'
    | '/okrs/org-chart'
    | '/operators/$threadId'
    | '/operators/automations'
    | '/settings/account'
    | '/settings/admin'
    | '/settings/usage'
    | '/dashboards/'
    | '/okrs/'
    | '/operators/'
    | '/settings/'
    | '/dashboards/custom/$slug'
    | '/operators/skills/$skillId'
    | '/operators/skills/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$threadId'
    | '/event-queue'
    | '/'
    | '/dashboards/$dashboardId'
    | '/dashboards/account-management'
    | '/dashboards/attrition'
    | '/dashboards/cal-killer'
    | '/dashboards/call-audio'
    | '/dashboards/care-navigation'
    | '/dashboards/cn-call-review'
    | '/dashboards/data-dictionary'
    | '/dashboards/dcmp-billing'
    | '/dashboards/eng-velocity'
    | '/dashboards/enrollment'
    | '/dashboards/inbound-calls'
    | '/dashboards/product-priorities'
    | '/dashboards/reengagement-emails'
    | '/dashboards/respite'
    | '/dashboards/retell-calls'
    | '/dashboards/revenue'
    | '/dashboards/sales'
    | '/dashboards/switchboard'
    | '/dashboards/website-traffic'
    | '/okrs/okrs'
    | '/okrs/org-chart'
    | '/operators/$threadId'
    | '/operators/automations'
    | '/settings/account'
    | '/settings/admin'
    | '/settings/usage'
    | '/dashboards'
    | '/okrs'
    | '/operators'
    | '/settings'
    | '/dashboards/custom/$slug'
    | '/operators/skills/$skillId'
    | '/operators/skills'
  id:
    | '__root__'
    | '/_app'
    | '/_app/$threadId'
    | '/_app/dashboards'
    | '/_app/event-queue'
    | '/_app/okrs'
    | '/_app/operators'
    | '/_app/settings'
    | '/_app/'
    | '/_app/dashboards/$dashboardId'
    | '/_app/dashboards/account-management'
    | '/_app/dashboards/attrition'
    | '/_app/dashboards/cal-killer'
    | '/_app/dashboards/call-audio'
    | '/_app/dashboards/care-navigation'
    | '/_app/dashboards/cn-call-review'
    | '/_app/dashboards/data-dictionary'
    | '/_app/dashboards/dcmp-billing'
    | '/_app/dashboards/eng-velocity'
    | '/_app/dashboards/enrollment'
    | '/_app/dashboards/inbound-calls'
    | '/_app/dashboards/product-priorities'
    | '/_app/dashboards/reengagement-emails'
    | '/_app/dashboards/respite'
    | '/_app/dashboards/retell-calls'
    | '/_app/dashboards/revenue'
    | '/_app/dashboards/sales'
    | '/_app/dashboards/switchboard'
    | '/_app/dashboards/website-traffic'
    | '/_app/okrs/okrs'
    | '/_app/okrs/org-chart'
    | '/_app/operators/$threadId'
    | '/_app/operators/automations'
    | '/_app/settings/account'
    | '/_app/settings/admin'
    | '/_app/settings/usage'
    | '/_app/dashboards/'
    | '/_app/okrs/'
    | '/_app/operators/'
    | '/_app/settings/'
    | '/_app/dashboards/custom/$slug'
    | '/_app/operators/skills/$skillId'
    | '/_app/operators/skills/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operators': {
      id: '/_app/operators'
      path: '/operators'
      fullPath: '/operators'
      preLoaderRoute: typeof AppOperatorsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/okrs': {
      id: '/_app/okrs'
      path: '/okrs'
      fullPath: '/okrs'
      preLoaderRoute: typeof AppOkrsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/event-queue': {
      id: '/_app/event-queue'
      path: '/event-queue'
      fullPath: '/event-queue'
      preLoaderRoute: typeof AppEventQueueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards': {
      id: '/_app/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof AppDashboardsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$threadId': {
      id: '/_app/$threadId'
      path: '/$threadId'
      fullPath: '/$threadId'
      preLoaderRoute: typeof AppThreadIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/operators/': {
      id: '/_app/operators/'
      path: '/'
      fullPath: '/operators/'
      preLoaderRoute: typeof AppOperatorsIndexRouteImport
      parentRoute: typeof AppOperatorsRoute
    }
    '/_app/okrs/': {
      id: '/_app/okrs/'
      path: '/'
      fullPath: '/okrs/'
      preLoaderRoute: typeof AppOkrsIndexRouteImport
      parentRoute: typeof AppOkrsRoute
    }
    '/_app/dashboards/': {
      id: '/_app/dashboards/'
      path: '/'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof AppDashboardsIndexRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/settings/usage': {
      id: '/_app/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof AppSettingsUsageRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/admin': {
      id: '/_app/settings/admin'
      path: '/admin'
      fullPath: '/settings/admin'
      preLoaderRoute: typeof AppSettingsAdminRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/account': {
      id: '/_app/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppSettingsAccountRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/operators/automations': {
      id: '/_app/operators/automations'
      path: '/automations'
      fullPath: '/operators/automations'
      preLoaderRoute: typeof AppOperatorsAutomationsRouteImport
      parentRoute: typeof AppOperatorsRoute
    }
    '/_app/operators/$threadId': {
      id: '/_app/operators/$threadId'
      path: '/$threadId'
      fullPath: '/operators/$threadId'
      preLoaderRoute: typeof AppOperatorsThreadIdRouteImport
      parentRoute: typeof AppOperatorsRoute
    }
    '/_app/okrs/org-chart': {
      id: '/_app/okrs/org-chart'
      path: '/org-chart'
      fullPath: '/okrs/org-chart'
      preLoaderRoute: typeof AppOkrsOrgChartRouteImport
      parentRoute: typeof AppOkrsRoute
    }
    '/_app/okrs/okrs': {
      id: '/_app/okrs/okrs'
      path: '/okrs'
      fullPath: '/okrs/okrs'
      preLoaderRoute: typeof AppOkrsOkrsRouteImport
      parentRoute: typeof AppOkrsRoute
    }
    '/_app/dashboards/website-traffic': {
      id: '/_app/dashboards/website-traffic'
      path: '/website-traffic'
      fullPath: '/dashboards/website-traffic'
      preLoaderRoute: typeof AppDashboardsWebsiteTrafficRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/switchboard': {
      id: '/_app/dashboards/switchboard'
      path: '/switchboard'
      fullPath: '/dashboards/switchboard'
      preLoaderRoute: typeof AppDashboardsSwitchboardRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/sales': {
      id: '/_app/dashboards/sales'
      path: '/sales'
      fullPath: '/dashboards/sales'
      preLoaderRoute: typeof AppDashboardsSalesRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/revenue': {
      id: '/_app/dashboards/revenue'
      path: '/revenue'
      fullPath: '/dashboards/revenue'
      preLoaderRoute: typeof AppDashboardsRevenueRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/retell-calls': {
      id: '/_app/dashboards/retell-calls'
      path: '/retell-calls'
      fullPath: '/dashboards/retell-calls'
      preLoaderRoute: typeof AppDashboardsRetellCallsRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/respite': {
      id: '/_app/dashboards/respite'
      path: '/respite'
      fullPath: '/dashboards/respite'
      preLoaderRoute: typeof AppDashboardsRespiteRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/reengagement-emails': {
      id: '/_app/dashboards/reengagement-emails'
      path: '/reengagement-emails'
      fullPath: '/dashboards/reengagement-emails'
      preLoaderRoute: typeof AppDashboardsReengagementEmailsRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/product-priorities': {
      id: '/_app/dashboards/product-priorities'
      path: '/product-priorities'
      fullPath: '/dashboards/product-priorities'
      preLoaderRoute: typeof AppDashboardsProductPrioritiesRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/inbound-calls': {
      id: '/_app/dashboards/inbound-calls'
      path: '/inbound-calls'
      fullPath: '/dashboards/inbound-calls'
      preLoaderRoute: typeof AppDashboardsInboundCallsRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/enrollment': {
      id: '/_app/dashboards/enrollment'
      path: '/enrollment'
      fullPath: '/dashboards/enrollment'
      preLoaderRoute: typeof AppDashboardsEnrollmentRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/eng-velocity': {
      id: '/_app/dashboards/eng-velocity'
      path: '/eng-velocity'
      fullPath: '/dashboards/eng-velocity'
      preLoaderRoute: typeof AppDashboardsEngVelocityRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/dcmp-billing': {
      id: '/_app/dashboards/dcmp-billing'
      path: '/dcmp-billing'
      fullPath: '/dashboards/dcmp-billing'
      preLoaderRoute: typeof AppDashboardsDcmpBillingRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/data-dictionary': {
      id: '/_app/dashboards/data-dictionary'
      path: '/data-dictionary'
      fullPath: '/dashboards/data-dictionary'
      preLoaderRoute: typeof AppDashboardsDataDictionaryRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/cn-call-review': {
      id: '/_app/dashboards/cn-call-review'
      path: '/cn-call-review'
      fullPath: '/dashboards/cn-call-review'
      preLoaderRoute: typeof AppDashboardsCnCallReviewRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/care-navigation': {
      id: '/_app/dashboards/care-navigation'
      path: '/care-navigation'
      fullPath: '/dashboards/care-navigation'
      preLoaderRoute: typeof AppDashboardsCareNavigationRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/call-audio': {
      id: '/_app/dashboards/call-audio'
      path: '/call-audio'
      fullPath: '/dashboards/call-audio'
      preLoaderRoute: typeof AppDashboardsCallAudioRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/cal-killer': {
      id: '/_app/dashboards/cal-killer'
      path: '/cal-killer'
      fullPath: '/dashboards/cal-killer'
      preLoaderRoute: typeof AppDashboardsCalKillerRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/attrition': {
      id: '/_app/dashboards/attrition'
      path: '/attrition'
      fullPath: '/dashboards/attrition'
      preLoaderRoute: typeof AppDashboardsAttritionRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/account-management': {
      id: '/_app/dashboards/account-management'
      path: '/account-management'
      fullPath: '/dashboards/account-management'
      preLoaderRoute: typeof AppDashboardsAccountManagementRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/dashboards/$dashboardId': {
      id: '/_app/dashboards/$dashboardId'
      path: '/$dashboardId'
      fullPath: '/dashboards/$dashboardId'
      preLoaderRoute: typeof AppDashboardsDashboardIdRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
    '/_app/operators/skills/': {
      id: '/_app/operators/skills/'
      path: '/skills'
      fullPath: '/operators/skills/'
      preLoaderRoute: typeof AppOperatorsSkillsIndexRouteImport
      parentRoute: typeof AppOperatorsRoute
    }
    '/_app/operators/skills/$skillId': {
      id: '/_app/operators/skills/$skillId'
      path: '/skills/$skillId'
      fullPath: '/operators/skills/$skillId'
      preLoaderRoute: typeof AppOperatorsSkillsSkillIdRouteImport
      parentRoute: typeof AppOperatorsRoute
    }
    '/_app/dashboards/custom/$slug': {
      id: '/_app/dashboards/custom/$slug'
      path: '/custom/$slug'
      fullPath: '/dashboards/custom/$slug'
      preLoaderRoute: typeof AppDashboardsCustomSlugRouteImport
      parentRoute: typeof AppDashboardsRoute
    }
  }
}

interface AppDashboardsRouteChildren {
  AppDashboardsDashboardIdRoute: typeof AppDashboardsDashboardIdRoute
  AppDashboardsAccountManagementRoute: typeof AppDashboardsAccountManagementRoute
  AppDashboardsAttritionRoute: typeof AppDashboardsAttritionRoute
  AppDashboardsCalKillerRoute: typeof AppDashboardsCalKillerRoute
  AppDashboardsCallAudioRoute: typeof AppDashboardsCallAudioRoute
  AppDashboardsCareNavigationRoute: typeof AppDashboardsCareNavigationRoute
  AppDashboardsCnCallReviewRoute: typeof AppDashboardsCnCallReviewRoute
  AppDashboardsDataDictionaryRoute: typeof AppDashboardsDataDictionaryRoute
  AppDashboardsDcmpBillingRoute: typeof AppDashboardsDcmpBillingRoute
  AppDashboardsEngVelocityRoute: typeof AppDashboardsEngVelocityRoute
  AppDashboardsEnrollmentRoute: typeof AppDashboardsEnrollmentRoute
  AppDashboardsInboundCallsRoute: typeof AppDashboardsInboundCallsRoute
  AppDashboardsProductPrioritiesRoute: typeof AppDashboardsProductPrioritiesRoute
  AppDashboardsReengagementEmailsRoute: typeof AppDashboardsReengagementEmailsRoute
  AppDashboardsRespiteRoute: typeof AppDashboardsRespiteRoute
  AppDashboardsRetellCallsRoute: typeof AppDashboardsRetellCallsRoute
  AppDashboardsRevenueRoute: typeof AppDashboardsRevenueRoute
  AppDashboardsSalesRoute: typeof AppDashboardsSalesRoute
  AppDashboardsSwitchboardRoute: typeof AppDashboardsSwitchboardRoute
  AppDashboardsWebsiteTrafficRoute: typeof AppDashboardsWebsiteTrafficRoute
  AppDashboardsIndexRoute: typeof AppDashboardsIndexRoute
  AppDashboardsCustomSlugRoute: typeof AppDashboardsCustomSlugRoute
}

const AppDashboardsRouteChildren: AppDashboardsRouteChildren = {
  AppDashboardsDashboardIdRoute: AppDashboardsDashboardIdRoute,
  AppDashboardsAccountManagementRoute: AppDashboardsAccountManagementRoute,
  AppDashboardsAttritionRoute: AppDashboardsAttritionRoute,
  AppDashboardsCalKillerRoute: AppDashboardsCalKillerRoute,
  AppDashboardsCallAudioRoute: AppDashboardsCallAudioRoute,
  AppDashboardsCareNavigationRoute: AppDashboardsCareNavigationRoute,
  AppDashboardsCnCallReviewRoute: AppDashboardsCnCallReviewRoute,
  AppDashboardsDataDictionaryRoute: AppDashboardsDataDictionaryRoute,
  AppDashboardsDcmpBillingRoute: AppDashboardsDcmpBillingRoute,
  AppDashboardsEngVelocityRoute: AppDashboardsEngVelocityRoute,
  AppDashboardsEnrollmentRoute: AppDashboardsEnrollmentRoute,
  AppDashboardsInboundCallsRoute: AppDashboardsInboundCallsRoute,
  AppDashboardsProductPrioritiesRoute: AppDashboardsProductPrioritiesRoute,
  AppDashboardsReengagementEmailsRoute: AppDashboardsReengagementEmailsRoute,
  AppDashboardsRespiteRoute: AppDashboardsRespiteRoute,
  AppDashboardsRetellCallsRoute: AppDashboardsRetellCallsRoute,
  AppDashboardsRevenueRoute: AppDashboardsRevenueRoute,
  AppDashboardsSalesRoute: AppDashboardsSalesRoute,
  AppDashboardsSwitchboardRoute: AppDashboardsSwitchboardRoute,
  AppDashboardsWebsiteTrafficRoute: AppDashboardsWebsiteTrafficRoute,
  AppDashboardsIndexRoute: AppDashboardsIndexRoute,
  AppDashboardsCustomSlugRoute: AppDashboardsCustomSlugRoute,
}

const AppDashboardsRouteWithChildren = AppDashboardsRoute._addFileChildren(
  AppDashboardsRouteChildren,
)

interface AppOkrsRouteChildren {
  AppOkrsOkrsRoute: typeof AppOkrsOkrsRoute
  AppOkrsOrgChartRoute: typeof AppOkrsOrgChartRoute
  AppOkrsIndexRoute: typeof AppOkrsIndexRoute
}

const AppOkrsRouteChildren: AppOkrsRouteChildren = {
  AppOkrsOkrsRoute: AppOkrsOkrsRoute,
  AppOkrsOrgChartRoute: AppOkrsOrgChartRoute,
  AppOkrsIndexRoute: AppOkrsIndexRoute,
}

const AppOkrsRouteWithChildren =
  AppOkrsRoute._addFileChildren(AppOkrsRouteChildren)

interface AppOperatorsRouteChildren {
  AppOperatorsThreadIdRoute: typeof AppOperatorsThreadIdRoute
  AppOperatorsAutomationsRoute: typeof AppOperatorsAutomationsRoute
  AppOperatorsIndexRoute: typeof AppOperatorsIndexRoute
  AppOperatorsSkillsSkillIdRoute: typeof AppOperatorsSkillsSkillIdRoute
  AppOperatorsSkillsIndexRoute: typeof AppOperatorsSkillsIndexRoute
}

const AppOperatorsRouteChildren: AppOperatorsRouteChildren = {
  AppOperatorsThreadIdRoute: AppOperatorsThreadIdRoute,
  AppOperatorsAutomationsRoute: AppOperatorsAutomationsRoute,
  AppOperatorsIndexRoute: AppOperatorsIndexRoute,
  AppOperatorsSkillsSkillIdRoute: AppOperatorsSkillsSkillIdRoute,
  AppOperatorsSkillsIndexRoute: AppOperatorsSkillsIndexRoute,
}

const AppOperatorsRouteWithChildren = AppOperatorsRoute._addFileChildren(
  AppOperatorsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute
  AppSettingsAdminRoute: typeof AppSettingsAdminRoute
  AppSettingsUsageRoute: typeof AppSettingsUsageRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSettingsAdminRoute: AppSettingsAdminRoute,
  AppSettingsUsageRoute: AppSettingsUsageRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppThreadIdRoute: typeof AppThreadIdRoute
  AppDashboardsRoute: typeof AppDashboardsRouteWithChildren
  AppEventQueueRoute: typeof AppEventQueueRoute
  AppOkrsRoute: typeof AppOkrsRouteWithChildren
  AppOperatorsRoute: typeof AppOperatorsRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppThreadIdRoute: AppThreadIdRoute,
  AppDashboardsRoute: AppDashboardsRouteWithChildren,
  AppEventQueueRoute: AppEventQueueRoute,
  AppOkrsRoute: AppOkrsRouteWithChildren,
  AppOperatorsRoute: AppOperatorsRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
